import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Comprehensive ResizeObserver error suppression
// This is a harmless browser warning that doesn't affect functionality
const originalConsoleError = window.console.error;
window.console.error = (...args) => {
  const errorString = args[0]?.toString?.() || '';
  if (
    errorString.includes('ResizeObserver loop') ||
    errorString.includes('ResizeObserver') ||
    args[0]?.includes?.('ResizeObserver loop') ||
    args[0]?.includes?.('ResizeObserver')
  ) {
    return; // Suppress ResizeObserver errors
  }
  originalConsoleError(...args);
};

// Suppress uncaught ResizeObserver errors at window level
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true); // Use capture phase

// Also handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes?.('ResizeObserver')) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
